import { AppBar, Toolbar, useMediaQuery } from "@mui/material";
import React from "react";
export var PageHeading = function (props) {
    var children = props.children, sx = props.sx, _a = props.className, className = _a === void 0 ? true : _a;
    var lgMode = useMediaQuery(function (theme) { return theme.breakpoints.up('sm'); });
    return lgMode ? /*#__PURE__*/ React.createElement(Toolbar, {
        sx: sx,
        className: className ? "border-bottom-custom" : ""
    }, children) : /*#__PURE__*/ React.createElement(AppBar, {
        position: "fixed",
        sx: {
            backgroundColor: "white",
            boxShadow: 'none'
        }
    }, /*#__PURE__*/ React.createElement(Toolbar, {
        sx: sx,
        className: className ? "border-bottom-custom" : ""
    }, children));
};
